"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var styles = exports.styles = function styles(theme) {
  return {
    paper: {
      width: '100%',
      zIndex: 10
    },
    absolute: {
      position: 'absolute'
    },
    relative: {
      position: 'relative'
    },
    left: {
      width: '200%',
      left: 0
    },
    right: {
      width: '200%',
      left: '-100%'
    },
    overlay: (0, _objectSpread2.default)({
      padding: 0,
      height: 325,
      textAlign: 'center'
    }, theme.typography.body2),
    header: (0, _objectSpread2.default)({
      display: 'block',
      height: 40,
      textAlign: 'center',
      padding: '10px 0'
    }, theme.typography.body2, {
      color: theme.palette.neutral.main,
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.divider
    }),
    body: {
      height: 245,
      width: 224,
      margin: 'auto'
    },
    footer: {
      height: 40,
      padding: '10px 0',
      borderTop: '1px solid',
      borderTopColor: theme.palette.divider
    }
  };
};
var CustomOverlayLayout = function CustomOverlayLayout(_ref) {
  var classes = _ref.classes,
    children = _ref.children,
    headerElement = _ref.headerElement,
    footerElement = _ref.footerElement,
    absoluteElement = _ref.absoluteElement,
    side = _ref.side,
    staticPosition = _ref.staticPosition,
    props = (0, _objectWithoutProperties2.default)(_ref, ["classes", "children", "headerElement", "footerElement", "absoluteElement", "side", "staticPosition"]);
  var paperClass = (0, _classnames.default)(classes.paper, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.left, side === 'from'), classes.right, side === 'to'), classes.absolute, staticPosition !== true), classes.relative, staticPosition === true));
  var paperProps = (0, _objectSpread2.default)({}, props);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-handler-names
    _react.default.createElement(_Paper.default, {
      className: paperClass,
      onBlur: paperProps.onBlur,
      onFocus: paperProps.onFocus
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.overlay
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.header
    }, headerElement), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.body
    }, children), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.footer
    }, footerElement), absoluteElement))
  );
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  name: 'HmuiCustomOverlayLayout'
})(CustomOverlayLayout);